import { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import SubmitButton from './partials/SubmitButton';
import ErrorMessage from './partials/ErrorMessage';
import TextLink from './partials/TextLink';

import { MSDIcon } from '../../misc/icons/Icons';
import Inputfield from '../../misc/Inputfield';
import useTranslation from '../../../hooks/useTranslations';
import { resendActivationKey, selectResendActivationKeyError, selectResendActivationKeyStatus } from '../../../redux/modules/authSlice';

const ForgotPasswordScreen = () => {
	const t = useTranslation();
	const dispatch = useDispatch();

	const resendActivationKeyStatus = useSelector((state) => selectResendActivationKeyStatus(state));
	const resendActivationKeyError = useSelector((state) => selectResendActivationKeyError(state));

	const [email, setEmail] = useState('');

	const [emailError, setEmailError] = useState(null);

	const validateFields = () => {
		setEmailError(null);

		let valid = true;

		if (!email) {
			setEmailError(t('register_validation_mail'));
			valid = false;
		} else if (!(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(email).toLowerCase()))) {
			setEmailError(t('register_validation_mail_not_valid'));
			valid = false;
		}

		if (!valid) {
			return false;
		}
		return true;
	};

	const handleResendActivationKey = () => {
		if (validateFields()) {
			dispatch(resendActivationKey({ email }));
		}
	};

	// if successKey == "user_activated" {
	// 	message = t("register_success_activation")
	// } else if successKey == "user_deactivated" {
	// 	message = t("register_success_distributor")
	// }

	return (
		<div className="flex flex-col justify-center min-h-screen py-12 sm:pb-48 sm:px-6 lg:px-8">
			<div className="px-4 sm:mx-auto sm:w-full sm:max-w-md">
				<MSDIcon className="mx-auto w-42 h-14 sm:w-60 sm:h-20 text-oly-blue-dark" />
				<h2 className="mt-8 font-bold text-center text-[1.5625rem] text-oly-gray-darkest">
					{t('webapp_forgot_activationkey')}
				</h2>
				{resendActivationKeyStatus === 'success' && (
					<>
						<h3 className="mt-2 font-bold text-center text-[1.0625rem] text-oly-gray-darkest">
							{t('forgot_success')}
						</h3>
						<div className="flex items-center justify-center mx-1 mt-8">
							<TextLink href="/login" text={t('webapp_login_back')} title={t('general_back')} />
						</div>
					</>
				)}
			</div>
			{resendActivationKeyStatus !== 'success' && (
				<div className="mx-4 mt-8 sm:mx-auto sm:w-full sm:max-w-2xl">
					<div className="px-4 py-8 bg-white rounded-sm shadow sm:px-10">
						<form action="#" method="POST" onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
							<div className="flex flex-col gap-y-4 sm:gap-y-6">

								<div className="flex flex-col gap-y-4 sm:flex-row sm:gap-x-4 sm:gap-y-0">
									<div className="w-full">
										<Inputfield fieldName="email" label={t('register_mail_placeholder')} type="text" initialValue={email} placeholder={t('register_validation_mail')} handleChange={setEmail} showLabel />
										{emailError && <ErrorMessage message={emailError} />}
									</div>
								</div>

							</div>

							<div className="mx-auto mt-6 sm:px-10 sm:max-w-md">
								<SubmitButton type="submit" title={t('feedback_submit')} loading={resendActivationKeyStatus === 'pending'} handleClick={handleResendActivationKey} />
								{resendActivationKeyError && <ErrorMessage message={t(resendActivationKeyError)} />}
							</div>
						</form>
						<div className="flex items-center justify-between mx-1 mt-8">
							<TextLink href="/login" text={t('webapp_login_back')} title={t('general_back')} />
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default ForgotPasswordScreen;
